import React, { useState } from 'react'
import {
  FilterMultiSelect,
  IFilterMultiSelectOption,
  IFilterMultiSelectProps,
} from 'transfix-ui/components/FilterMultiSelect'

export interface IFilterMultiSelectDisplayProps extends Omit<IFilterMultiSelectProps, 'onSelect'> {
  /**
   * Handler that fires when apply is called
   * @param {string[]} selected - Array of selected values
   * @param {string} id - ID of the FilterMultiSelectDisplay, typically used as the attribute sent to the backend
   */
  onSelectHandler: (selected?: string[], id?: string) => void
  hasValues?: boolean
}

/**
 * FilterMultiSelectDisplay
 * Wrapper around FilterMultiSelect that extracts the state of the selected values
 *
 * @param onSelectHandler only returns the selected values
 */
const FilterMultiSelectDisplay = ({
  hasValues,
  onSelectHandler,
  options,
  ...rest
}: IFilterMultiSelectDisplayProps) => {
  const [selected, setSelected] = useState(options)

  const onOptionSelect = (optionsList?: IFilterMultiSelectOption[]) => {
    if (!optionsList) return
    const optionValues = optionsList.filter(opt => opt.selected).map(opt => opt.value)
    const selectedOptions = optionValues.length > 0 ? optionValues : undefined

    setSelected(optionsList)
    onSelectHandler(selectedOptions, rest.id)
  }

  const props = {
    ...rest,
    onSelect: onOptionSelect,
    options: hasValues ? selected : options,
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <FilterMultiSelect {...props} />
}

export default FilterMultiSelectDisplay
